"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Mail, MapPin, Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactSection() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  return <section ref={sectionRef} className="relative bg-light-background py-16 px-4 sm:px-8 lg:px-16">
      <div className="mx-auto max-w-7xl">
        <div className={`mb-12 text-center transition-all duration-500 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="mb-4 text-4xl font-bold text-foreground-light lg:text-5xl">
            Get in Touch
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-foreground-body">
            We're here to answer your questions and schedule your appointment. Reach out today!
          </p>
        </div>

        <div className="grid gap-8 lg:grid-cols-2 lg:gap-12">
          <Card className={`bg-background-card shadow-soft transition-all duration-700 delay-100 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <CardContent className="space-y-8">
              <div>
                <h3 className="mb-6 text-2xl font-semibold text-foreground-light">
                  Alpha Dental
                </h3>
                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary/10">
                      <MapPin className="size-5 text-foreground-light" />
                    </div>
                    <div>
                      <p className="font-medium text-foreground-light">Office Address</p>
                      <p className="mt-1 text-foreground-body">
                        916 Coronado Blvd
                        <br />
                        Universal City, TX 78148
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary/10">
                      <Phone className="size-5 text-foreground-light" />
                    </div>
                    <div>
                      <p className="font-medium text-foreground-light">Phone</p>
                      <Link to="tel:2107755177" className="mt-1 inline-block text-foreground-light hover:underline focus:outline-none focus:ring-2 focus:ring-primary/30 focus:ring-offset-2 transition-all">
                        (210) 775-5177
                      </Link>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary/10">
                      <Mail className="size-5 text-foreground-light" />
                    </div>
                    <div>
                      <p className="font-medium text-foreground-light">Email</p>
                      <Link to="mailto:alphainfo916@gmail.com" className="mt-1 inline-block text-foreground-light hover:underline focus:outline-none focus:ring-2 focus:ring-primary/30 focus:ring-offset-2 transition-all">
                        alphainfo916@gmail.com
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-3 sm:flex-row">
                <Button asChild className="flex-1 bg-primary text-foreground-primary hover:bg-primary-hover shadow-soft">
                  <Link to="tel:2107755177">
                    <Phone className="size-4" />
                    Call Now
                  </Link>
                </Button>
                <Button asChild variant="outline" className="flex-1 border-secondary bg-background-card text-foreground-light hover:bg-secondary/10 shadow-soft">
                  <Link to="https://www.appointnow.com/?P=4826&O=101&PT=0&campaignID=" newTab>
                    Schedule Appointment
                  </Link>
                </Button>
              </div>
            </CardContent>
          </Card>

          <div className={`h-[400px] overflow-hidden rounded-xl shadow-soft transition-all duration-700 delay-200 lg:h-auto ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3473.4937805524!2d-98.29425492394944!3d29.54767684508446!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865c8a5c5a5a5a5a%3A0x5a5a5a5a5a5a5a5a!2s916%20Coronado%20Blvd%2C%20Universal%20City%2C%20TX%2078148!5e0!3m2!1sen!2sus!4v1234567890123" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Alpha Dental Office Location - 916 Coronado Blvd, Universal City, TX 78148" className="grayscale-[30%] contrast-110" />
          </div>
        </div>
      </div>
    </section>;
}